import { platformAdpter } from "../util/adpter";
import { FanjuSdk } from "./FanjuSdk";

export class AllPlatformSdk extends FanjuSdk {
    async backWeb() {
        return platformAdpter<ReturnType<FanjuSdk['backWeb']>>({
            ios: async () => {
                // 喵喵
                if (window?.webkit?.messageHandlers?.evaluateJsToNative?.postMessage) {
                    window.webkit.messageHandlers.evaluateJsToNative.postMessage(JSON.stringify({ action: 'close' }));
                }
                // 饭橘
                if (window?.webkit?.messageHandlers?.webToNative?.postMessage) {
                    window.webkit.messageHandlers.webToNative.postMessage(JSON.stringify({ action: 'goBack', data: JSON.stringify({}) }));
                }
            },
            android: async () => {
                // 喵喵
                if (window?.callNative?.evaluateJsToNative) {
                    window.callNative.evaluateJsToNative(JSON.stringify({ action: 'close' }));
                }
                // 饭橘
                if (window?.android?.handBackClick) {
                    window.android.handBackClick();
                }
            },
            harmony: async () => {
                // 喵喵
                if (window?.callNative?.evaluateJsToNative) {
                    window.callNative.evaluateJsToNative(JSON.stringify({ action: 'close' }));
                }
                // 饭橘
                if (window?.android?.handBackClick) {
                    window.android.handBackClick();
                }
            },
        });
    }
}